<template>
  <div class="index-swiper-box">
      <swiper :options="swiperOption"  v-if="indexTopBanner && indexTopBanner.length">
        <swiper-slide v-for="(banner, index) in indexTopBanner" :key="index">
          <img @click="goPage(banner)" class="index-swiper-img" :src="banner.img" :onerror="defaultImg" />
        </swiper-slide>
      </swiper>
       <div class="swiper-pagination swiper-pagination-banner"></div>
  </div>
</template>

<script>
import { getCookie } from '@/utils/cookies'
import { toLogin } from '@/utils/common'
export default {
  name: 'm-index-banner',
  props: ['indexTopBanner'],
  data () {
    return {
      defaultImg: '../assets/images/icon_user.png',
      swiperOption: {
        autoplay: {
          delay: 3000
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination-banner',
          type: 'bullets'
        },
        observer: true,
        observeParents: true
      }
    }
  },
  methods: {
    goPage (banner) {
      if (banner.mustLogin) {
        if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
          toLogin()
          return
        }
        if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
          toLogin()
          return
        }
      }
      if (banner.url) {
        window.location.href = banner.url
      }
    }
  }
}
</script>

<style lang="scss">
  .index-swiper-box {
    width: 343px;
    height: 147px;
    margin: 0 auto;
    border-radius: 8px;
    overflow: hidden;
    position: relative;

    .index-swiper-img {
      border-radius: 8px;
      width: 343px;
      height: 147px;
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-overflow-scrolling: touch;
    }
    .swiper-pagination {
      bottom: 6px;
      left: 0;
      right: 0;
      margin: auto;
    }
    .swiper-wrapper {
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-overflow-scrolling: touch;
    }
    .swiper-pagination-bullet {
      width: 4px;
      height: 4px;
      opacity: 1;
      background: rgba(29,111,233,0.30);
      border-radius: 2px;
      margin: 0 2px;
    }
    .swiper-pagination-bullet-active {
       width: 12px;
      height: 4px;
      opacity: 1;
      background: #1d6fe9;
      border-radius: 2px;
    }
    .van-swipe__track {
      height: 147px!important;
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-overflow-scrolling: touch;
    }
    .van-swipe__indicators {
      bottom: 8px;
    }
    .van-swipe__indicator {
      width: 4px;
      height: 4px;
      opacity: 1;
      background: rgba(29,111,233,0.30);
      border-radius: 2px;
    }
    .van-swipe__indicator--active {
      width: 12px;
      height: 4px;
      opacity: 1;
      background: #1d6fe9;
      border-radius: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexBanner.vue